module.exports = __webpack_public_path__ + "static/media/fletBed.38936cc5.svg";